<template>
  <tbody>
    <template v-for="(item, index) in data">
      <tr
        v-if="isChanged(item._?.paymentName?.status)"
        :key="`payment-name-${index}`"
      >
        <th class="header-color">
          {{
            generateHeaderTitle('Tên tài khoản', item._?.paymentType?.current)
          }}
        </th>
        <td>{{ item._.paymentName.original }}</td>
        <td>{{ item._.paymentName.current }}</td>
      </tr>

      <tr
        v-if="isChanged(item._?.paymentCode?.status)"
        :key="`payment-code-${index}`"
      >
        <th class="header-color">
          {{
            generateHeaderTitle('Mã tham chiếu', item._?.paymentType?.current)
          }}
        </th>
        <td>{{ item._.paymentCode.original }}</td>
        <td>{{ item._.paymentCode.current }}</td>
      </tr>

      <tr
        v-if="isChanged(item._?.viaQRCode?.status)"
        :key="`via-qr-code-${index}`"
      >
        <th class="header-color">
          {{
            generateHeaderTitle('Thông qua mã QR', item._?.paymentType?.current)
          }}
        </th>
        <td>{{ getViaQrCodeName(item._.viaQRCode.original) }}</td>
        <td>{{ getViaQrCodeName(item._.viaQRCode.current) }}</td>
      </tr>

      <tr
        v-if="isChanged(item._?.paymentType?.status)"
        :key="`payment-type-${index}`"
      >
        <th class="header-color">
          {{
            generateHeaderTitle(
              'Hình thức thanh toán',
              item._?.paymentType?.current,
            )
          }}
        </th>
        <td>{{ getPaymentTypeName(item._?.paymentType?.original) }}</td>
        <td>{{ getPaymentTypeName(item._?.paymentType?.current) }}</td>
      </tr>

      <tr
        v-if="isChanged(item._?.paymentOptionType?.status)"
        :key="`payment-option-type-${index}`"
      >
        <th class="header-color">
          {{
            generateHeaderTitle(
              'Hình thức trả phí',
              item._.paymentOptionType.current,
            )
          }}
        </th>
        <td>
          {{ getPaymentOptionTypeName(item._.paymentOptionType.original) }}
        </td>
        <td>
          {{ getPaymentOptionTypeName(item._.paymentOptionType.current) }}
        </td>
      </tr>

      <tr
        v-if="isChanged(item._?.creditCardNo?.status)"
        :key="`credit-card-${index}`"
      >
        <th class="header-color">
          {{ generateHeaderTitle('Số thẻ', item._?.paymentType?.current) }}
        </th>
        <td>{{ item._.creditCardNo.original }}</td>
        <td>{{ item._.creditCardNo.current }}</td>
      </tr>

      <tr
        v-if="isChanged(item._?.paymentRefCode?.status)"
        :key="`payment-ref-${index}`"
      >
        <th class="header-color">
          {{
            generateHeaderTitle(
              'Mã tài khoản liên kết',
              item._?.paymentType?.current,
            )
          }}
        </th>
        <td>{{ item._.paymentRefCode.original }}</td>
        <td>{{ item._.paymentRefCode.current }}</td>
      </tr>

      <tr
        v-if="isChanged(item._?.status?.status)"
        :key="`payment-status-${index}`"
      >
        <th class="header-color">
          {{
            generateHeaderTitle(
              'Trạng thái thanh toán',
              item._?.paymentType?.current,
            )
          }}
        </th>
        <td>{{ getStatusText(item._.status.original) }}</td>
        <td>{{ getStatusText(item._.status.current) }}</td>
      </tr>

      <tr
        v-if="isChanged(item._?.customerIndentifyNo.status)"
        :key="`customer-id-${index}`"
      >
        <th class="header-color">
          {{
            generateHeaderTitle(
              'Số CMND khách hàng',
              item._?.paymentType?.current,
            )
          }}
        </th>
        <td>{{ item._.customerIndentifyNo.original }}</td>
        <td>{{ item._.customerIndentifyNo.current }}</td>
      </tr>

      <!-- Child Payments -->
      <template v-for="(childItem, childIndex) in item._?.child">
        <tr
          v-if="isChanged(childItem?.paymentName?.status)"
          :key="`child-payment-name-${index}-${childIndex}`"
        >
          <th class="header-color child-row">
            {{ generateChildHeaderTitle('Tên tài khoản') }}
          </th>
          <td>{{ childItem.paymentName?.original }}</td>
          <td>{{ childItem.paymentName?.current }}</td>
        </tr>

        <tr
          v-if="isChanged(childItem?.paymentCode?.status)"
          :key="`child-payment-code-${index}-${childIndex}`"
        >
          <th class="header-color child-row">
            {{ generateChildHeaderTitle('Mã tham chiếu') }}
          </th>
          <td>{{ childItem.paymentCode?.original }}</td>
          <td>{{ childItem.paymentCode?.current }}</td>
        </tr>

        <tr
          v-if="isChanged(childItem?.viaQRCode?.status)"
          :key="`child-via-qr-code-${index}-${childIndex}`"
        >
          <th class="header-color child-row">
            {{ generateChildHeaderTitle('Thông qua mã QR') }}
          </th>
          <td>{{ getViaQrCodeName(childItem.viaQRCode?.original) }}</td>
          <td>{{ getViaQrCodeName(childItem.viaQRCode?.current) }}</td>
        </tr>

        <tr
          v-if="isChanged(childItem?.paymentType?.status)"
          :key="`child-payment-type-${index}-${childIndex}`"
        >
          <th class="header-color child-row">
            {{ generateChildHeaderTitle('Hình thức thanh toán') }}
          </th>
          <td>{{ getPaymentTypeName(childItem.paymentType?.original) }}</td>
          <td>{{ getPaymentTypeName(childItem.paymentType?.current) }}</td>
        </tr>

        <tr
          v-if="isChanged(childItem?.paymentOptionType?.status)"
          :key="`child-payment-option-type-${index}-${childIndex}`"
        >
          <th class="header-color child-row">
            {{
              generateChildHeaderTitle(
                'Hình thức trả phí',
                childItem.paymentOptionType?.current,
              )
            }}
          </th>
          <td>
            {{
              getPaymentOptionTypeName(childItem.paymentOptionType?.original)
            }}
          </td>
          <td>
            {{ getPaymentOptionTypeName(childItem.paymentOptionType?.current) }}
          </td>
        </tr>

        <tr
          v-if="isChanged(childItem?.creditCardNo?.status)"
          :key="`child-credit-card-${index}-${childIndex}`"
        >
          <th class="header-color child-row">
            {{
              generateChildHeaderTitle('Số thẻ', childItem.paymentType?.current)
            }}
          </th>
          <td>{{ childItem.creditCardNo?.original }}</td>
          <td>{{ childItem.creditCardNo?.current }}</td>
        </tr>

        <tr
          v-if="isChanged(childItem?.paymentRefCode?.status)"
          :key="`child-payment-ref-${index}-${childIndex}`"
        >
          <th class="header-color child-row">
            {{ generateChildHeaderTitle('Mã tài khoản liên kết') }}
          </th>
          <td>{{ childItem.paymentRefCode?.original }}</td>
          <td>{{ childItem.paymentRefCode?.current }}</td>
        </tr>

        <tr
          v-if="isChanged(childItem?.status?.status)"
          :key="`child-payment-status-${index}-${childIndex}`"
        >
          <th class="header-color child-row">
            {{ generateChildHeaderTitle('Trạng thái thanh toán') }}
          </th>
          <td>{{ getStatusText(childItem.status?.original) }}</td>
          <td>{{ getStatusText(childItem.status?.current) }}</td>
        </tr>

        <tr
          v-if="isChanged(childItem?.customerIndentifyNo?.status)"
          :key="`child-customer-id-${index}-${childIndex}`"
        >
          <th class="header-color child-row">
            {{ generateChildHeaderTitle('Số CMND khách hàng') }}
          </th>
          <td>{{ childItem.customerIndentifyNo?.original }}</td>
          <td>{{ childItem.customerIndentifyNo?.current }}</td>
        </tr>
      </template>
    </template>
  </tbody>
</template>

<script>
import ENUM_NAME from '@/utils/enum-name';

export default {
  name: 'PaymentChanges',
  props: {
    data: {
      type: Array,
      required: true,
    },
  },

  methods: {
    isChanged(value) {
      return value && value !== 'EQUAL';
    },

    generateHeaderTitle(title, paymentType) {
      const paymentTypeName = this.getPaymentTypeName(paymentType) || 'N/A';
      return `${title} (${paymentTypeName})`.trimEnd();
    },

    generateChildHeaderTitle(title) {
      return `${title} (Phụ)`;
    },

    getPaymentTypeName(paymentType) {
      return ENUM_NAME.PAYMENT_TYPE_NAME[paymentType] || '';
    },

    getPaymentOptionTypeName(paymentOptionType) {
      return ENUM_NAME.PAYMENT_OPTION_TYPE_NAME[paymentOptionType] || '';
    },

    getViaQrCodeName(viaQrCode) {
      return viaQrCode ? 'Có' : 'Không';
    },

    getStatusText(status) {
      return ENUM_NAME.PAYMENT_STATUS_NAME[status] || '';
    },
  },
};
</script>

<style scoped>
.header-color {
  font-weight: 500;
}
</style>
